<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Senarai Penyesuaian Fail">
            <w-form ref="dform" @validate="search">
                <w-flex class="mt3">
                    <div class="xs6 mr3"> 
                        <z-lookup
                            label="Jenis Pembayaran"
                            :url="service_ibayaq + 'lookup/sumber'"
                            :sort="false"
                            :cache="false"
                            v-model="cari.lkp_sumber_id"
                        />
                    </div>
                    <div class="xs6 mr3">
                    <w-input
                      label="Nama Fail"
                      v-model="cari.nama_fail"
                    />
                </div>
                </w-flex>
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            v-model="cari.jabatan_id"
                            label="Jabatan "
                        />
                    </div>
                    <div class="xs6 mr3">
                    <z-input 
                          label="Tarikh Proses"
                          v-model="cari.created_at"
                          type="date"/>
                    </div>
                </w-flex>
            </w-form>

            <w-flex class="mt1 mb3" justify-end>
                <div class="mt2 text-right">
                    <w-button
                        class="ml1"
                        v-on:click="reset()"
                        bg-color="warning"
                    >
                        <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                    </w-button>
                    <w-button class="ml1" @click="$refs.dform.validate()">
                        <w-icon>fal fa-search</w-icon>&nbsp;Cari
                    </w-button>
                </div>
            </w-flex>
            <!-- <z-table
                ref="tbluser"
                title=""
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.nama="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <template v-for="(dt, index) in table.items">
                        <template v-if="dt.nama_fail">
                            <a :href="dt.link_fail">{{dt.nama_fail}}</a>
                        </template>
                        </template>
                    </w-flex>
                </template>
            </z-table> -->
            <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <table class="table-dashboard" width="100%">
                        <thead>
                            <tr class="center">
                                <td>Bil</td>
                                <td>Nama Fail</td>
                                <td>Jabatan</td>
                                <td>Tarikh Fail</td>
                                <!-- <td rowspan="2">Tindakan</td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(dt, index) in table.items">
                                <td>{{dt.no}}</td>
                                <td><template v-if="dt.nama_fail">
                                        <a :href="dt.link_fail">{{dt.nama_fail}}</a>
                                    </template></td>
                                <td>{{dt.jabatan_id}}</td>
                                <td>{{dt.tarikh}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </w-flex>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
// import ZenOne from '@/Shared/ZenOne'
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_ibayaq + "penyesuaian_fail",
            reload: true,
            form_profil: {},
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Penyesuaian", route: "/" },
                { label: "Penyesuaian Fail ", route: "/penyesuaian_fail" },
            ],
            cari: {
                lkp_sumber_id: "",
                jabatan_id: "",
                created_at: "",
                nama_fail: "",
            },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("penyesuaian.fail.recon") +
                    "?created_at=" +
                    this.cari.created_at+
                    "&lkp_sumber_id=" +
                    this.cari.lkp_sumber_id +
                    "&jabatan_id=" +
                    this.cari.jabatan_id +
                    "&nama_fail=" +
                    this.cari.nama_fail,
                { preserveScroll: true }
            );
        },

        reset() {
            this.cari = {
                lkp_sumber_id: "",
                jabatan_id: "",
                created_at: "",
                nama_fail: "",
            };
            this.search();
        },
    },
    watch: {},
    mounted() {
        // override default setting
        // this.getData();
        this.dialog.width = 900;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.lkp_sumber_id == "undefined") {
            this.cari.lkp_sumber_id = "";
        }
        if (this.cari.jabatan_id == "undefined") {
            this.cari.jabatan_id = "";
        }
        if (this.cari.created_at == "undefined") {
            this.cari.created_at = "";
        }
        if (this.cari.nama_fail == "undefined") {
            this.cari.nama_fail = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
